import React from 'react';

import ItemCard from './ItemCard';
import { Divider, NoItemsContainer } from './styles';

import usePageStore from '../../../../../../store/pageStore';

export default function ItemSelection() {

  //!
  const vtexOrderItems = usePageStore((state) => state.vtexOrderItems);
  const setVtexItemQuantity = usePageStore(
    (state) => state.setVtexItemQuantity,
  );

  return (
    <>
      {vtexOrderItems?.map((item, index) => (
        <>
          <ItemCard
            key={item.uniqueId}
            itemData={item}
            selectedQuantity={item.selectedQuantity}
            setSelectedQuantity={(event) =>
              setVtexItemQuantity(item.uniqueId, event.target.value)
            }
          />
          {index !== vtexOrderItems.length - 1 && <Divider />}
        </>
      )) ?? <NoItemsContainer>Nenhum Item</NoItemsContainer>}
    </>
  );
}
